import { BoxTypes } from "./BoxTypes";

const MONTHS = [
    { label: "Janeiro", value: 1 },
    { label: "Fevereiro", value: 2 },
    { label: "Março", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Maio", value: 5 },
    { label: "Junho", value: 6 },
    { label: "Julho", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Setembro", value: 9 },
    { label: "Outubro", value: 10 },
    { label: "Novembro", value: 11 },
    { label: "Dezembro", value: 12 },
]

export class BoxValidations {

    static validate(boxType, data) {
        switch (boxType) {
            case BoxTypes.FullAudience: {
                return true;
            }
            case BoxTypes.SavedAudience: {
                return !!data?.id || !!data?.audienceId;
            }
            case BoxTypes.EventSource: {
                return !!data?.eventType;
            }
            case BoxTypes.BroadcastAudience: {
                return data?.broadcast?.type === 'ALL' || data?.broadcast?.states?.length > 0;
            }
            case BoxTypes.AgeFilter:
            case BoxTypes.AgeConditional:
            case BoxTypes.AverageTicketFilter:
            case BoxTypes.AverageTicketConditional:
            case BoxTypes.TotalSpendFilter:
            case BoxTypes.TotalSpendConditional:
            case BoxTypes.OrderCountFilter:
            case BoxTypes.OrderCountConditional:
            case BoxTypes.OrderFrequencyFilter:
            case BoxTypes.OrderFrequencyConditional:
            case BoxTypes.DaysWithoutConversionFilter:
            case BoxTypes.DaysWithoutConversionConditional: {
                const isValidExact = typeof data.exact == 'number';
                const isValidMin = typeof data.min == 'number' && typeof data.max != 'number';
                const isValidMinMax = typeof data.max == 'number' && typeof data.min == 'number' && data.min < data.max;
                const isValidPeriod = typeof data.inLast == 'number' ? ['DAY', 'MONTH', 'YEAR'].includes(data.inLastPeriod) : true;
                // console.log({isValidExact, isValidMin, isValidMinMax, isValidPeriod});
                return (isValidExact || isValidMin || isValidMinMax) && isValidPeriod;
            }
            case BoxTypes.LastConversionFilter:
            case BoxTypes.LastConversionConditional:
            case BoxTypes.RegisterTimeFilter:
            case BoxTypes.RegisterTimeConditional: {
                return typeof data.inLast == 'number' && ['DAY', 'MONTH', 'YEAR'].includes(data.inLastPeriod);
            }
            case BoxTypes.RegionFilter:
            case BoxTypes.RegionConditional: {
                return data?.regions?.length > 0;
            }
            case BoxTypes.RFVProfileFilter:
            case BoxTypes.RFVProfileConditional: {
                return data?.values?.length > 0;
            }
            case BoxTypes.BirthdayFilter:
            case BoxTypes.BirthdayConditional: {
                if (data.moment == 'DIFF_NEXT_DATE') {
                    return typeof data.value == 'number';
                } else if (data.moment == 'MONTH') {
                    return !!(MONTHS.find((m) => data.value == m.value));
                } else {
                    return data.moment == 'DAY';
                }
            }
            case BoxTypes.SpecificDayConditional: {
                return !!data?.date;
            }
            case BoxTypes.DayOfWeekConditional: 
            case BoxTypes.DayOfMonthConditional: {
                return data?.days?.length > 0;
            }
            case BoxTypes.BrandsAndUnitsFilter:
            case BoxTypes.BrandsAndUnitsConditional: {
                return data?.units?.length > 0;
            }
            case BoxTypes.OriginFilter:
            case BoxTypes.OriginConditional: {
                return data?.origins?.length > 0;
            }
            case BoxTypes.AudienceGroup: {
                return !!data?.audiences?.length && data?.audiences.reduce((prev, curr) => prev && BoxValidations.validate(curr.type, curr.data), true);
            }
            case BoxTypes.FilterGroup: {
                return !!data?.filters?.length && data?.filters.reduce((prev, curr) => prev && BoxValidations.validate(curr.type, curr.data), true);
            }
            case BoxTypes.ConditionalGroup: {
                return !!data?.conditionals?.length && data?.conditionals.reduce((prev, curr) => prev && BoxValidations.validate(curr.type, curr.data), true);
            }
            case BoxTypes.CreativeGroupAction: {
                return !!data?.creatives?.length;
            }
            default:
                return true;
        }
    }
}